// extracted by mini-css-extract-plugin
module.exports = {"component":"input-component--3CDPK"};